export const PROFILE_GOAL_DRAFT_KEY = 'pinpoint:profile-goal-draft';

/**
 * Remove application-owned, session-scoped drafts at the authentication
 * boundary. This must not depend on a user lookup: expiry can end a session
 * before the authoritative identity has loaded.
 */
export function clearSessionOwnedDrafts(): void {
  if (typeof window === 'undefined') return;
  window.sessionStorage.removeItem(PROFILE_GOAL_DRAFT_KEY);
}
